module.exports = __webpack_public_path__ + "img/odo-sand-simple.6f83e62f.svg";